import { RefObject, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { ErrorMessage, Field } from 'formik'
import useClickOutside from 'components/Hooks/useClickOutside'
import { Button } from 'ui'

import { t } from 'translations'

interface DayPickerSingleProps {
  name: string
  value: number
  setFieldTouched: (field: string, isTouched: boolean) => void
  isSubmitting: boolean
  isValidating: boolean
  width?: number | string
}

export const DayPickerSingle: React.FC<DayPickerSingleProps> = ({ name, value, setFieldTouched, isSubmitting, isValidating, width }) => {
  const { defaultBeginningOfWeekDay } = useSelector((state: MStore.RootState) => state.settings)
  const dayOrder = ['0', '1', '2', '3', '4', '5', '6']
  const dayIndex = [...dayOrder.slice(defaultBeginningOfWeekDay), ...dayOrder.slice(0, defaultBeginningOfWeekDay)]
  const [isOpen, setIsOpen] = useState(false)
  const ref = useClickOutside(() => {
    setIsOpen(false)
  }) as RefObject<HTMLDivElement> | null

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setIsOpen(false)
    }
    window.addEventListener('keydown', handleKeyDown)
    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [])

  useEffect(() => {
    if (isSubmitting && !isValidating) {
      setFieldTouched(name, true)
    }
  }, [isSubmitting, isValidating, name, setFieldTouched])

  const toggleMenu = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.preventDefault()
    setFieldTouched(name, true)
    setIsOpen(!isOpen)
  }

  return (
    <div className="w-100">
      <div className="position-relative" ref={ref}>
        <Button color="light" style={{ width: width ? width : 175 }} onClick={toggleMenu}>
          {value ? t(`components.dayOfWeekNoColon.${value}`) : t('administration.wagePremiums.form.SELECT')}
          <i className="ml-2 fas fa-caret-down pointer-cursor" />
        </Button>
        {isOpen ? (
          <div className="form-control p-0 position-absolute mt-1" style={{ zIndex: '20', width: width ? width : 150, height: 'fit-content' }}>
            <div className="m-2">
              {dayIndex.map(day => (
                <div key={day} className="m-2">
                  <label>
                    <Field type="radio" name={name} value={day} />
                    {t(`components.dayOfWeekNoColon.${day}`)}
                  </label>
                </div>
              ))}
            </div>
          </div>
        ) : null}
      </div>
      <ErrorMessage name={name} render={msg => <div className="text-danger">{t(msg)}</div>} />
    </div>
  )
}
